export var GLOBAL = {
	//url: 'http://apilaravel.com.devel/'+'api/'
	url: 'https://apilaravel.tumecontratas.delcastic.com/'+'api/'
	
};